import { render } from "./CreateTypeRamification.vue?vue&type=template&id=57edac0a"
import script from "./CreateTypeRamification.vue?vue&type=script&lang=js"
export * from "./CreateTypeRamification.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__